import { styled } from '@mui/material/styles';

import Switch from "@mui/material/Switch";

const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex',
    borderRadius: 10,
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 20
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(16px)',
        }
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '& + .MuiSwitch-track': {
            backgroundColor: '#F16868'
        },
        '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#40B2E0'
            }
        }
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        borderRadius: 8,
        transition: theme.transitions.create(['width', 'transform'], {
            duration: 200
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: '#40B2E0',
        boxSizing: 'border-box'
    },
}));

export default StyledSwitch;
